import React from "react";
import styles from "./index.module.scss";
import ImagePreview from "../../common/components/ImagePreview";

interface Field {
  label: string;
  value: string;
  type: string;
}

interface DetailsBoxProps {
  fields: Field[];
  cardTitle: string;
  fieldsPerRow?: number;
}

const FieldItem: React.FC<Field> = ({ label, value, type }) => {
  const [open, setOpen] = React.useState(false);
  const [previewImageUrl, setPreviewImageUrl] = React.useState({
    image: "",
    altText: "",
  });
  if (type === "divider") {
    return (
      <div className={styles.dividerContainer}>
        <hr className={styles.divider} />
      </div>
    );
  }

  // Handle draganddrop type here
  let displayValue = value;
  if (type === "draganddrop") {
    try {
      const pref = JSON.parse(decodeURIComponent(value));
      const sortedPref = Array.isArray(pref)
        ? [...pref].sort((a, b) => a.priorityOrder - b.priorityOrder)
        : pref;
      displayValue = sortedPref
        .map((session: any) =>
          session.sessionName &&
          session.sessionName !== null &&
          session.sessionName !== ""
            ? `${session.sessionName}`
            : `${session.sessionId}`,
        )
        .join(", ");
        if(sortedPref.length === 0) {
          displayValue = "Mahatria's Choice";
        }
      // eslint-disable-next-line no-console
      console.log("Sorted drag and drop value:", sortedPref);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Invalid drag and drop value", e);
      displayValue = value;
    }
  }

  const _renderValue = () => {
    
    switch (type) {
      case "file":
        console.log("Rendering value for type:", type, "with value:", value , "and label:", label);
        return ( 
          <div className={styles.labelWithImage}>
            <span className={styles.label}>{label}</span>
            {/* <img src={value} alt={label} className={styles.previewImageSide} /> */}
            <div className={styles.imageContainer}>
              <img
              src={value}
              alt={label}
              className={styles.previewImageSide} 
              onClick={() => {
                setPreviewImageUrl({
                  image: value,
                  altText: label
                })
                setOpen(true)
              }}
              />
              <div className={styles.hoverEyePreview} onClick={() => {
                setPreviewImageUrl({
                  image: value,
                  altText: label
                })
                setOpen(true)
              }}></div>
              <ImagePreview imageUrl={previewImageUrl.image} altText={previewImageUrl.altText} setOpen={setOpen} isOpen = {open}></ImagePreview>
            </div>
          </div>
        );
      case "video":
        return (
          <div className={`${styles.labelWithImage} ${styles.videoContainer}`}>
            <video
              src={value}
              controls
              className={styles.previewVideo}
              onClick={() => {
                setPreviewImageUrl({
                  image: value,
                  altText: label
                })
                setOpen(true)
              }}
            />
          </div>
        );
      case "string":
      case "draganddrop":
      default:
        return <div className={styles.value}>{displayValue}</div>;
    }
  };

  return (
    <div className={styles.fieldItem}>
      {type === "file" ? (
        _renderValue()
      ) : (
        <>
          <div className={styles.label}>{label}</div>
          {_renderValue()}
        </>
      )}
    </div>
  );
};

export const DetailsBox: React.FC<DetailsBoxProps> = ({
  fields,
  cardTitle,
  fieldsPerRow = 3,
}) => {
  // Group fields into rows based on fieldsPerRow
  const _rows = [];
  for (let _i = 0; _i < fields.length; _i += fieldsPerRow) {
    _rows.push(fields.slice(_i, _i + fieldsPerRow));
  }

  return (
    <div className={styles.detailsBox}>
      <div className={styles.cardTitle}>{cardTitle}</div>
      {_rows.map((_row, _idx) => (
        <div className={styles.fieldsRow} key={_idx}>
          {_row.map((_field, _fidx) => (
            <FieldItem
              key={_fidx}
              label={_field.label}
              value={_field.value}
              type={_field.type}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default FieldItem;
